import {z} from 'zod';
import {keyComparator, zDateTime, zNumberToString} from '@brunata-angular/util';

export const buildingDetailsSchema = z.object({
    building: z.object({
        buildingNo: zNumberToString,
        buildingName: z.string().nullable(),
        address1: z.string().nullable(),
        address2: z.string().nullable(),
        postalCode: z.string().nullable(),
        city: z.string().nullable(),
        buildingType: z.string(),
        phoneCode: z.string().nullable(),
        dataPrivacyRetentionLength: z.number(),
        buildingBasicDataId: zNumberToString,
    }),
    periods: z.array(
        z
            .object({
                periodstartdate: zDateTime,
                periodenddate: zDateTime,
            })
            .transform(period => ({
                periodStartDate: period.periodstartdate,
                periodEndDate: period.periodenddate,
            })),
    ),
    accounts: z
        .array(
            z.object({
                accountNo: z.number(),
                accountType: z.string(),
            }),
        )
        .transform(accounts => [...accounts].sort(keyComparator(account => account.accountNo))),
    buildingServices: z.array(z.number()),
    meterAggregations: z.array(
        z.object({
            meterType: z.number(),
            allocationUnit: z.string(),
            allocationUnitSortOrder: z.number().nullable(),
            count: z.number(),
        }),
    ),
});

export type BuildingDetails = z.infer<typeof buildingDetailsSchema>;
